import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';

import validate from '../../handles/validate';

const TextField = (
    {
      label = '',
      defaultValue = '',
      handleError = () => false,
      showError = true,
      onChange = () => false,
      validators = {},
      requirement = {},
      fieldDisabled = false,
      guide = '',
    }) => {
  const [value, setValue] = useState(defaultValue);
  const [errors, setErrors] = useState({hasError: false, messages: []});

  const requirementArray = Object.values(requirement);

  useEffect(() => {
    const validated = validate(value, validators, label);
    setErrors(validated);
    handleError(label, validated.messages);
  }, [value, ...requirementArray]);

  const handleChange = ({target: {value}}) => {
    setValue(value);
    onChange(value.trim());
  };

  const checkRequirement = () => {
    return requirementArray === requirementArray.filter((item) => item.value);
  };

  return <div className="row row_top">
    <div className="col-md-12">
      <span className="field-label">{label}</span>
      <div>
        <input type="text" placeholder="" className="textInput"
               disabled={fieldDisabled || checkRequirement()}
               name="userName" onChange={handleChange} value={value}/>
        {!errors.hasError || !showError ||
        errors.messages.map(
            (msg, index) => <div key={index} className="errMsg">{msg}</div>)}
        {!guide || <p className={"guide"}>{guide}</p>}
      </div>
    </div>
  </div>;
};

// Predefine proptypes
TextField.propTypes = {
  label: PropTypes.string,
  defaultValue: PropTypes.string,
  handleError: PropTypes.func,
  showError: PropTypes.bool,
  onChange: PropTypes.func,
  validators: PropTypes.object,
  requirement: PropTypes.object,
  fieldDisabled: PropTypes.bool,
  guide: PropTypes.string,
};

export default TextField;
